import { Injectable } from '@angular/core';
import { CustomerService } from 'src/api/services/customer.service';
import { Customer } from 'src/api/models/customer';
import { BehaviorSubject, Observable } from "rxjs";
import { StrictHttpResponse } from 'src/api/strict-http-response';

export class CustomerSelection{
  public customerId: number;
}

@Injectable()
export class CustomerTableService {

    public remoteData: Observable<Customer[]>;
    private _remoteData: BehaviorSubject<Customer[]>;

    constructor(private readonly service: CustomerService) {
      this._remoteData = new BehaviorSubject([]);
      this.remoteData = this._remoteData.asObservable();
    }

    get() {
      this.service.CustomerGetAllCustomerDetails().subscribe(results => {
        this._remoteData.next(results);
      });
    }

    add(customer: Customer) : Observable<Customer> {
      return this.service.CustomerCreateCustomer(customer)
    }

    remove(customer: Customer) : Observable<Blob> {
      return this.service.CustomerDeleteCustomerById(customer.customerId);
    }

    update(customer: Customer) : Observable<Customer> {
      return this.service.CustomerUpdateCustomer(customer);
    }
 

}
